import {
  GetAllCoursesByPersonUseCaseInterface,
  GetAllEntitiesByPersonUseCaseInterface,
  GetAllPersonProfileUseCaseInterface,
  GetPersonByIdV2UseCaseInterface,
} from 'domain/usecases';
import { notifyError } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { useCallback, useState } from 'react';

export const usePersonDetails = () => {
  const [person, setPerson] =
    useState<GetPersonByIdV2UseCaseInterface.Result>();
  const [personProfiles, setPersonProfiles] =
    useState<GetAllPersonProfileUseCaseInterface.Result>(null);
  const [loadingPerson, setLoadingPerson] = useState<boolean>(true);
  const [entitiesByPerson, setEntitiesByPerson] =
    useState<GetAllEntitiesByPersonUseCaseInterface.Result>([]);
  const [coursesByPerson, setCoursesByPerson] =
    useState<GetAllCoursesByPersonUseCaseInterface.Result>([]);

  const { personService, entitiesService, courseService } = useService();

  const requestGetPersonById = useCallback(
    async (params: GetPersonByIdV2UseCaseInterface.Params) => {
      setLoadingPerson(true);

      try {
        const res = await personService.getPersonByIdV2(params);
        setPerson(res);
      } catch (err: unknown) {
        console.log(err);
      } finally {
        setLoadingPerson(false);
      }
    },
    [],
  );

  const requestGetAllPersonProfile = useCallback(
    async (params: GetAllPersonProfileUseCaseInterface.Params) => {
      await personService
        .getAllPersonProfile(params)
        .then((res) => {
          setPersonProfiles(res);
        })
        .catch((res) => {
          notifyError(res);
        })
        .finally(() => {});
    },
    [],
  );

  const requestGetAllEntitiesByPerson = useCallback(
    async (params: GetAllEntitiesByPersonUseCaseInterface.Params) => {
      try {
        const res = await entitiesService.getAllEntitiesByPerson(params);
        setEntitiesByPerson(res);
      } catch (err: unknown) {
        console.log(err);
      }
    },
    [],
  );

  const requestGetAllCoursesByPerson = useCallback(
    async (params: GetAllCoursesByPersonUseCaseInterface.Params) => {
      try {
        const res = await courseService.getAllCoursesByPerson(params);
        setCoursesByPerson(res);
      } catch (err: unknown) {
        console.log(err);
      }
    },
    [],
  );

  return {
    person,
    loadingPerson,
    personProfiles,
    coursesByPerson,
    entitiesByPerson,
    requestGetPersonById,
    requestGetAllPersonProfile,
    requestGetAllCoursesByPerson,
    requestGetAllEntitiesByPerson,
  };
};
